import { __callbacks } from "Utils/Callbacks/Callback";
import { __chatState } from "Utils/Chats/ChatState";
import { AppContext, ChatContext } from "Utils/Contexts";
import { AppState, ChatState } from "Utils/Enums";
import { useCallback, useContext, useEffect, useState } from "react";
import styles from "./Chat.module.scss";
import Body from "./components/Body/Body";
import Footer from "./components/Footer/Footer";
import ButtonStartChat from "components/ButtonStartChat/ButtonStartChat";
import { __bot } from 'Utils/Bot/Bot'; 
import { __chats } from "../../Utils/Chats/Chats";
import { __config } from "Utils/Configs/Config";
export default function Chat(props: any) {
    const appStateContext = useContext(AppContext);
    const chatStateContext = useContext(ChatContext);
    const [classHide, setClassHide] = useState("");
    const [classHideFooter, setClassHideFooter] = useState(styles["hide"]);
    const [classIsBot, setClassIsBot] = useState(styles["hide"]);
    const [currentChatId, setCurrentChatId] = useState(null);

    const initListeners = useCallback(() => {

        __callbacks.onDisableChatInputs((data: any) => {

            setClassHideFooter("");
            __callbacks.blurChatInput.trigger({});
            // save the chat state
            __chatState.override({
                chatId: data.chatId,
                disableInputs: true
            });
        });
        __callbacks.onEnableChatInputs((data: any) => {

            setClassHideFooter(styles["hide"]);
            __callbacks.focusChatInput.trigger({});
            // save the chat state
            __chatState.override({
                chatId: data.chatId,
                disableInputs: false
            });

            if (localStorage.getItem('bot_conversation' + __chats.getCurrentChatId()) !== 'true') {
                setClassIsBot(styles["hide"]);
            } else {
                setClassIsBot("");
            }

        });
    }, []);

    useEffect(() => {
        initListeners();
    }, [initListeners]);

    useEffect(() => {
        if (appStateContext === AppState.chat) {
            setClassHide("");
        } else {
            setClassHide(styles.hide);
        }
    }, [appStateContext]);

    useEffect(() => {
        __callbacks.onContinueConversation((data: any) => {
            const chatState = __chatState.get(data.conversationId);
            if (!chatState) return;

            setCurrentChatId(data.conversationId);

            if (chatState.disableInputs) {
                setClassHideFooter("");
            } else {
                setClassHideFooter(styles["hide"]);
                __callbacks.focusChatInput.trigger({});
            }
        });
    }, []);

    return (
        <div className={`${styles.container} ${classHide}`}>
            <div className={`${styles["container-body"]}`}>
                <Body></Body>
            </div>
            {__config.config.app.enable_chat && __config.config.app.ai && (
                <div className={`${styles.startChatButtonContainer} ${classIsBot}`}>
                    <ButtonStartChat />
                </div>
            )}
            <div className={`${styles["container-footer"]}`}>
                <Footer chatId={currentChatId}></Footer>
                <div className={`${styles["footer-blur"]} ${classHideFooter}`}></div>
            </div>
        </div>
    );
}
